import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { AppFlowService } from "../services/app-flow/app-flow.service";

@Injectable({
  providedIn: "root",
})
export class AppFlowRouteGuard  {
  constructor(private router: Router, private appFlowService: AppFlowService) {}

  // eslint-disable-next-line unused-imports/no-unused-vars-ts
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const current = next.routeConfig.path;
    if (this.appFlowService.canActivatePath(current)) {
      return true;
    }
    return this.router.parseUrl(`/notfound`);
  }
}
